// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AreSureModal_shureModalMain__wweMt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-top: 0px;
  gap: 10px;
  width: 100%;
}

.AreSureModal_shureText__moal1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 10px;
}

.AreSureModal_shureText__moal1 h4 {
  font-size: 2rem;
  font-weight: 600;
}

.AreSureModal_parentBtn__eP4Ey {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: flex-end;
}

.AreSureModal_parentBtn__eP4Ey button.AreSureModal_cancel__NefbG {
  padding-inline: 50px !important;
  background-color: transparent !important;
  border: 2px solid var(--red-color) !important;
  color: var(--red-color) !important;
  width: 100px !important;
  height: 40px !important;
}

.AreSureModal_send__b-kAe {
  width: 100px;
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/AreSureModal/AreSureModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,6CAA6C;EAC7C,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".shureModalMain {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  padding-top: 0px;\n  gap: 10px;\n  width: 100%;\n}\n\n.shureText {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  gap: 10px;\n}\n\n.shureText h4 {\n  font-size: 2rem;\n  font-weight: 600;\n}\n\n.parentBtn {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  justify-content: flex-end;\n}\n\n.parentBtn button.cancel {\n  padding-inline: 50px !important;\n  background-color: transparent !important;\n  border: 2px solid var(--red-color) !important;\n  color: var(--red-color) !important;\n  width: 100px !important;\n  height: 40px !important;\n}\n\n.send {\n  width: 100px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shureModalMain": `AreSureModal_shureModalMain__wweMt`,
	"shureText": `AreSureModal_shureText__moal1`,
	"parentBtn": `AreSureModal_parentBtn__eP4Ey`,
	"cancel": `AreSureModal_cancel__NefbG`,
	"send": `AreSureModal_send__b-kAe`
};
export default ___CSS_LOADER_EXPORT___;
